var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('the-header',[_c('lang-switch',{staticClass:"header-lang"})],1),_c('router-view'),_c('the-footer'),_c('float-contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }